module.exports = __webpack_public_path__ + "static/media/86.bcaed2a2.jpg";